module.exports = __webpack_public_path__ + "af49e84.woff";